import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  itemTargetConnected(item) {
    if (item.hasAttribute("data-open")) this.#openOnly(item);
  }

  open({ target }) {
    const item = this.#itemAround(target);
    this.#openOnly(item);
    this.#focusAtEnd(item.querySelector("textarea"));
  }

  reveal({ target }) {
    this.#itemAround(target).toggleAttribute("data-open", true);
  }

  close(event) {
    const item = this.#itemAround(event.target);
    const invalidField = [
      ...item.querySelectorAll("input, textarea, select"),
    ].find((field) => !field.checkValidity());
    if (invalidField) {
      event.stopImmediatePropagation();
      invalidField.reportValidity();
      return;
    }

    this.#openOnly(null);
    item.querySelector("[data-action~='accordion#open']")?.focus();
  }

  #focusAtEnd(field) {
    field?.focus();
    field?.setSelectionRange(field.value.length, field.value.length);
  }

  #itemAround(element) {
    return element.closest("[data-accordion-target~='item']");
  }

  #openOnly(openItem) {
    this.itemTargets.forEach((item) =>
      item.toggleAttribute("data-open", item === openItem),
    );
  }
}
